
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("531JC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $1b91c33fa3484455$export$3d5265f8773197d = ({ maxNumberOfItemsPerRow: maxNumberOfItemsPerRow, numberOfItems: numberOfItems, isRow: isRow })=>{
    // Indices represents the leftmost item and rightmost item currently in view.
    const [window, setWindow] = (0, $cozmU.useState)([
        0,
        0
    ]);
    // Used for scrolling to a particular item. Set to -1 by default as we haven't scrolled yet.
    const [scrollToIndex, setScrollToIndex] = (0, $cozmU.useState)(-1);
    // Used to keep track of which item is currently being edited in the config panel to adjust window accordingly.
    const [requestedScrollIndex, setRequestedScrollIndex] = (0, $cozmU.useState)(-1);
    (0, $cozmU.useEffect)(()=>{
        {
            // Viewable window indexes are inclusive of left and right index, so we need to decrement by one unless maxNumberOfItemsPerRow is 0.
            // Examples:
            // Cards: 1 2 3 4 5, Card indexes: 0 1 2 3 4
            // maxNumberOfItemsPerRow is 0, current left index is at card 1 (ie. index 0) --> right index should be at card 1 (index 0), 1 card in view. Calculation: 0 + 0 - 0 = 0
            // maxNumberOfItemsPerRow is 2, current left index is at card 1 (ie. index 0) --> right index should be at card 2 (index 1), 2 cards in view. Calculation: 0 + 2 - 1 = 1
            // maxNumberOfItemsPerRow is 3, current left index is at card 2 (ie. index 1) --> right index should be at card 4 (index 3), 3 cards in view. Calculation: 1 + 3 - 1 = 3
            const extraDecrement = maxNumberOfItemsPerRow === 0 ? 0 : 1;
            const newRightIndex = window[0] + maxNumberOfItemsPerRow - extraDecrement;
            setWindow([
                window[0],
                newRightIndex
            ]);
        }
        if (requestedScrollIndex >= 0) {
            // Trigger scroll unconditionally, this works for grid view as well (which doesn't use the window logic)
            setScrollToIndex(requestedScrollIndex);
            // Only update the window in row orientation, as we don't use a window for grid view.
            if (isRow) {
                if (requestedScrollIndex !== window[0] && requestedScrollIndex !== window[1]) {
                    // This means we've scrolled somewhere left beyond the existing visible window, so we update the window to the left.
                    if (requestedScrollIndex < window[0]) setWindow([
                        requestedScrollIndex,
                        requestedScrollIndex + maxNumberOfItemsPerRow - 1
                    ]);
                    else if (requestedScrollIndex > window[1]) setWindow([
                        requestedScrollIndex - maxNumberOfItemsPerRow + 1,
                        requestedScrollIndex
                    ]);
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        maxNumberOfItemsPerRow,
        requestedScrollIndex,
        isRow
    ]);
    const scrollToPrevious = (0, $cozmU.useCallback)(()=>{
        const newLeftIndex = window[0] - 1;
        const newRightIndex = window[1] - 1;
        setWindow([
            newLeftIndex,
            newRightIndex
        ]);
        setScrollToIndex(newLeftIndex);
    }, [
        window
    ]);
    const scrollToNext = ()=>{
        const newLeftIndex = window[0] + 1;
        const newRightIndex = window[1] + 1;
        setWindow([
            newLeftIndex,
            newRightIndex
        ]);
        setScrollToIndex(newRightIndex);
    };
    (0, $cozmU.useEffect)(()=>{
        // If user deletes an item near the end of the list, our window of
        // items being shown may need recalculating (if right index is too high)
        if (window[1] > numberOfItems - 1 && window[0] > 0) scrollToPrevious();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        numberOfItems,
        scrollToPrevious
    ]);
    const noScrollNeeded = numberOfItems <= maxNumberOfItemsPerRow;
    const isAtBeginning = noScrollNeeded || window[0] === 0;
    const isAtEnd = noScrollNeeded || window[1] === numberOfItems - 1;
    const resetScrollIndex = ()=>{
        setScrollToIndex(-1);
    };
    return {
        isAtBeginning: isAtBeginning,
        isAtEnd: isAtEnd,
        scrollToPrevious: scrollToPrevious,
        scrollToNext: scrollToNext,
        scrollToIndex: scrollToIndex,
        requestScrollIndex: setRequestedScrollIndex,
        resetScrollIndex: resetScrollIndex
    };
};
module.exports["useOrientationScrolling"] = $1b91c33fa3484455$export$3d5265f8773197d;

});

parcelRegister("gMXXV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $386ef889bd883882$export$1a197eb476b94cd9 = 16;
const $386ef889bd883882$export$622d6c2ee56322dc = 16;
const $386ef889bd883882$var$MAX_NUMBER_OF_ITEMS_PER_ROW = 6;
const $386ef889bd883882$export$a6443181a5681c94 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { numberOfCards: numberOfCards, cardDimensions: cardDimensions, gapBetweenItems: t1, getItemDimensions: getItemDimensions } = t0;
    const gapBetweenItems = t1 === undefined ? $386ef889bd883882$export$1a197eb476b94cd9 : t1;
    const [currentCardsGridWidth, setCurrentCardsGridWidth] = (0, $cozmU.useState)(0);
    const [currentCardWidth, setCurrentCardWidth] = (0, $cozmU.useState)(0);
    let t2;
    if ($[0] !== cardDimensions || $[1] !== getItemDimensions) {
        t2 = getItemDimensions ? getItemDimensions() : cardDimensions;
        $[0] = cardDimensions;
        $[1] = getItemDimensions;
        $[2] = t2;
    } else t2 = $[2];
    const dimensions = t2;
    const currentCardsGridWidthAdjustedForRounding = currentCardsGridWidth - 0.5;
    const numberOfCardsPerRow = Math.floor((currentCardsGridWidthAdjustedForRounding + gapBetweenItems) / (dimensions.minWidth + gapBetweenItems));
    const maxNumberOfCardsPerRow = Math.min(numberOfCardsPerRow, $386ef889bd883882$var$MAX_NUMBER_OF_ITEMS_PER_ROW);
    if (currentCardsGridWidthAdjustedForRounding <= dimensions.minWidth) {
        let t3;
        if ($[3] !== gapBetweenItems) {
            t3 = {
                spaceBetweenCards: gapBetweenItems,
                paddingRightGapOffset: 0
            };
            $[3] = gapBetweenItems;
            $[4] = t3;
        } else t3 = $[4];
        let t4;
        if ($[5] !== dimensions.minWidth || $[6] !== maxNumberOfCardsPerRow || $[7] !== t3) {
            t4 = {
                calculations: {
                    cardWidthOnFullRow: dimensions.minWidth,
                    isFirstRowFull: true,
                    isFirstRowOverflown: false,
                    isGridSmallerOrEqualWidthToCards: true,
                    gaps: t3,
                    maxNumberOfCardsPerRow: maxNumberOfCardsPerRow
                },
                setCurrentCardsGridWidth: setCurrentCardsGridWidth,
                setCurrentCardWidth: setCurrentCardWidth
            };
            $[5] = dimensions.minWidth;
            $[6] = maxNumberOfCardsPerRow;
            $[7] = t3;
            $[8] = t4;
        } else t4 = $[8];
        return t4;
    }
    const maxCardSizeOnFullRow = Math.floor((currentCardsGridWidthAdjustedForRounding - gapBetweenItems * (maxNumberOfCardsPerRow - 1)) / maxNumberOfCardsPerRow);
    const isFirstRowFull = numberOfCards >= maxNumberOfCardsPerRow;
    const isFirstRowOverflown = numberOfCards > maxNumberOfCardsPerRow;
    const cardWidthOnFullRow = Math.min(maxCardSizeOnFullRow, dimensions.maxWidth);
    const cardsOnFirstRow = Math.min(numberOfCards, maxNumberOfCardsPerRow);
    const numberOfRowGaps = Math.max(0, cardsOnFirstRow - 1);
    const extraSpaceInGrid = currentCardsGridWidthAdjustedForRounding - cardsOnFirstRow * currentCardWidth - numberOfRowGaps * gapBetweenItems;
    const maxAdditionalSpacePerGapBetweenCards = numberOfRowGaps === 0 ? 0 : Math.min(extraSpaceInGrid / numberOfRowGaps, $386ef889bd883882$export$622d6c2ee56322dc - $386ef889bd883882$export$1a197eb476b94cd9);
    const spaceBetweenCards = gapBetweenItems + maxAdditionalSpacePerGapBetweenCards;
    const paddingRightGapOffset = !isFirstRowFull ? 0 : (extraSpaceInGrid - numberOfRowGaps * maxAdditionalSpacePerGapBetweenCards) / 2;
    let t3;
    if ($[9] !== paddingRightGapOffset || $[10] !== spaceBetweenCards) {
        t3 = {
            spaceBetweenCards: spaceBetweenCards,
            paddingRightGapOffset: paddingRightGapOffset
        };
        $[9] = paddingRightGapOffset;
        $[10] = spaceBetweenCards;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== cardWidthOnFullRow || $[13] !== isFirstRowFull || $[14] !== isFirstRowOverflown || $[15] !== maxNumberOfCardsPerRow || $[16] !== t3) {
        const calculations = {
            cardWidthOnFullRow: cardWidthOnFullRow,
            isFirstRowFull: isFirstRowFull,
            isFirstRowOverflown: isFirstRowOverflown,
            isGridSmallerOrEqualWidthToCards: false,
            gaps: t3,
            maxNumberOfCardsPerRow: maxNumberOfCardsPerRow
        };
        t4 = {
            calculations: calculations,
            setCurrentCardsGridWidth: setCurrentCardsGridWidth,
            setCurrentCardWidth: setCurrentCardWidth
        };
        $[12] = cardWidthOnFullRow;
        $[13] = isFirstRowFull;
        $[14] = isFirstRowOverflown;
        $[15] = maxNumberOfCardsPerRow;
        $[16] = t3;
        $[17] = t4;
    } else t4 = $[17];
    return t4;
} : ({ numberOfCards: numberOfCards, cardDimensions: cardDimensions, gapBetweenItems: gapBetweenItems = $386ef889bd883882$export$1a197eb476b94cd9, getItemDimensions: getItemDimensions })=>{
    const [currentCardsGridWidth, setCurrentCardsGridWidth] = (0, $cozmU.useState)(0);
    const [currentCardWidth, setCurrentCardWidth] = (0, $cozmU.useState)(0);
    const dimensions = getItemDimensions ? getItemDimensions() : cardDimensions;
    /*
   * Width observer rounds the width of the container (currentCardsGridWidth) returning a whole number.
   * This means in situations that the width is rounded up, we have an edge case where we are
   * making calculations with a grid width larger than what we actually have leading to layout issues.
   *
   * It is better to adjust the width we get from the observer down (-.5px) and
   * have some cases where we have extra space (<=.5px) than the latter problem that causes layout issues.
   */ const currentCardsGridWidthAdjustedForRounding = currentCardsGridWidth - 0.5;
    const numberOfCardsPerRow = Math.floor((currentCardsGridWidthAdjustedForRounding + gapBetweenItems) / (dimensions.minWidth + gapBetweenItems));
    const maxNumberOfCardsPerRow = Math.min(numberOfCardsPerRow, $386ef889bd883882$var$MAX_NUMBER_OF_ITEMS_PER_ROW);
    if (currentCardsGridWidthAdjustedForRounding <= dimensions.minWidth) return {
        calculations: {
            cardWidthOnFullRow: dimensions.minWidth,
            isFirstRowFull: true,
            isFirstRowOverflown: false,
            isGridSmallerOrEqualWidthToCards: true,
            gaps: {
                spaceBetweenCards: gapBetweenItems,
                paddingRightGapOffset: 0
            },
            maxNumberOfCardsPerRow: maxNumberOfCardsPerRow
        },
        setCurrentCardsGridWidth: setCurrentCardsGridWidth,
        setCurrentCardWidth: setCurrentCardWidth
    };
    const maxCardSizeOnFullRow = Math.floor((currentCardsGridWidthAdjustedForRounding - gapBetweenItems * (maxNumberOfCardsPerRow - 1)) / maxNumberOfCardsPerRow);
    const isFirstRowFull = numberOfCards >= maxNumberOfCardsPerRow;
    const isFirstRowOverflown = numberOfCards > maxNumberOfCardsPerRow;
    const cardWidthOnFullRow = Math.min(maxCardSizeOnFullRow, dimensions.maxWidth);
    const cardsOnFirstRow = Math.min(numberOfCards, maxNumberOfCardsPerRow);
    const numberOfRowGaps = Math.max(0, cardsOnFirstRow - 1);
    const extraSpaceInGrid = currentCardsGridWidthAdjustedForRounding - cardsOnFirstRow * currentCardWidth - numberOfRowGaps * gapBetweenItems;
    // Preserve the original gap-distribution behaviour: any extra (or negative
    // rounding) space is spread across the gaps, capped at how much the gap is
    // allowed to grow beyond its minimum (MAX_GAP - MIN_GAP). This keeps the math
    // identical for the default gap while still honouring a larger space-density
    // `gapBetweenItems`.
    const maxAdditionalSpacePerGapBetweenCards = numberOfRowGaps === 0 ? 0 : Math.min(extraSpaceInGrid / numberOfRowGaps, $386ef889bd883882$export$622d6c2ee56322dc - $386ef889bd883882$export$1a197eb476b94cd9);
    const spaceBetweenCards = gapBetweenItems + maxAdditionalSpacePerGapBetweenCards;
    const paddingRightGapOffset = !isFirstRowFull ? 0 : (extraSpaceInGrid - numberOfRowGaps * maxAdditionalSpacePerGapBetweenCards) / 2;
    const calculations = {
        cardWidthOnFullRow: cardWidthOnFullRow,
        isFirstRowFull: isFirstRowFull,
        isFirstRowOverflown: isFirstRowOverflown,
        isGridSmallerOrEqualWidthToCards: false,
        gaps: {
            spaceBetweenCards: spaceBetweenCards,
            paddingRightGapOffset: paddingRightGapOffset
        },
        maxNumberOfCardsPerRow: maxNumberOfCardsPerRow
    };
    return {
        calculations: calculations,
        setCurrentCardsGridWidth: setCurrentCardsGridWidth,
        setCurrentCardWidth: setCurrentCardWidth
    };
};
module.exports["useWidthAndSpacingCalculations"] = $386ef889bd883882$export$a6443181a5681c94;

});

parcelRegister("5D0gt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $1LXnB = parcelRequire("1LXnB");


var $bIp5p = parcelRequire("bIp5p");


var $hjUDQ = parcelRequire("hjUDQ");

const $e48d13805ad5c50c$export$efa81a508b70a345 = {
    [(0, $hjUDQ.Height).SMALL]: {
        minWidth: 221,
        maxWidth: 380,
        height: 72
    },
    [(0, $hjUDQ.Height).MEDIUM]: {
        minWidth: 240,
        maxWidth: 308,
        height: 312
    },
    [(0, $hjUDQ.Height).LARGE]: {
        minWidth: 358,
        maxWidth: 640,
        height: 312
    }
};
const $e48d13805ad5c50c$export$1928c8795f1f40c6 = (cardSize)=>{
    return $e48d13805ad5c50c$export$efa81a508b70a345[cardSize];
};
const $e48d13805ad5c50c$var$styles = {
    wrapperStylesUpdated: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _1mT5xdRAKS _0aNu0LYbGa _313842Pgdg",
    wrapperWithInlinePadding: "_2Y7lL4FQfX"
};
const $e48d13805ad5c50c$export$11b226df951ea813 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { children: children, isFirstRowFull: isFirstRowFull, cardWidthOnFullRow: cardWidthOnFullRow, setWidth: setWidth, testId: t1, scrollToCard: scrollToCard, clearScrollToCard: clearScrollToCard, index: index, requestScrollIndex: requestScrollIndex, cardId: cardId, extensionLocalId: extensionLocalId, itemDimensions: itemDimensions, hasInlinePadding: t2, ariaRole: ariaRole } = t0;
    const testId = t1 === undefined ? "card-wrapper" : t1;
    const hasInlinePadding = t2 === undefined ? false : t2;
    const cardRef = (0, $cozmU.useRef)(null);
    const [t3] = (0, $bIp5p.useExtensionsState)();
    const { selectedExtensionLocalId: selectedExtensionLocalId, selectedToEditCardId: selectedToEditCardId } = t3;
    const cardDimensions = itemDimensions;
    let t4;
    let t5;
    if ($[0] !== cardId || $[1] !== clearScrollToCard || $[2] !== extensionLocalId || $[3] !== index || $[4] !== requestScrollIndex || $[5] !== scrollToCard || $[6] !== selectedExtensionLocalId || $[7] !== selectedToEditCardId) {
        t4 = ()=>{
            const scrollIntoViewBehavior = {
                behavior: "smooth",
                block: "nearest",
                inline: "nearest"
            };
            if (cardRef.current) {
                if (scrollToCard && (!selectedExtensionLocalId || extensionLocalId === selectedExtensionLocalId)) {
                    cardRef.current.scrollIntoView(scrollIntoViewBehavior);
                    clearScrollToCard();
                }
                if (selectedToEditCardId && selectedToEditCardId === cardId && extensionLocalId === selectedExtensionLocalId) requestScrollIndex(index);
                else if (!selectedToEditCardId) requestScrollIndex(-1);
            }
        };
        t5 = [
            cardRef,
            cardId,
            extensionLocalId,
            index,
            scrollToCard,
            clearScrollToCard,
            selectedExtensionLocalId,
            selectedToEditCardId,
            requestScrollIndex
        ];
        $[0] = cardId;
        $[1] = clearScrollToCard;
        $[2] = extensionLocalId;
        $[3] = index;
        $[4] = requestScrollIndex;
        $[5] = scrollToCard;
        $[6] = selectedExtensionLocalId;
        $[7] = selectedToEditCardId;
        $[8] = t4;
        $[9] = t5;
    } else {
        t4 = $[8];
        t5 = $[9];
    }
    (0, $cozmU.useEffect)(t4, t5);
    const t6 = isFirstRowFull ? `${cardWidthOnFullRow}px` : `${cardDimensions.minWidth}px`;
    const t7 = isFirstRowFull ? `${cardWidthOnFullRow}px` : `${cardDimensions.maxWidth}px`;
    let t8;
    if ($[10] !== t6 || $[11] !== t7) {
        t8 = {
            minWidth: t6,
            maxWidth: t7
        };
        $[10] = t6;
        $[11] = t7;
        $[12] = t8;
    } else t8 = $[12];
    const t9 = hasInlinePadding && $e48d13805ad5c50c$var$styles.wrapperWithInlinePadding;
    let t10;
    if ($[13] !== t9) {
        t10 = (0, $hekY6.default)([
            $e48d13805ad5c50c$var$styles.wrapperStylesUpdated,
            t9
        ]);
        $[13] = t9;
        $[14] = t10;
    } else t10 = $[14];
    let t11;
    if ($[15] !== index || $[16] !== setWidth) {
        t11 = index === 0 && setWidth && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.WidthObserver), {
            setWidth: setWidth,
            offscreen: true
        });
        $[15] = index;
        $[16] = setWidth;
        $[17] = t11;
    } else t11 = $[17];
    let t12;
    if ($[18] !== ariaRole || $[19] !== children || $[20] !== t10 || $[21] !== t11 || $[22] !== t8 || $[23] !== testId) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: ariaRole,
            style: t8,
            ref: cardRef,
            "data-testid": testId,
            className: t10
        }, children, t11);
        $[18] = ariaRole;
        $[19] = children;
        $[20] = t10;
        $[21] = t11;
        $[22] = t8;
        $[23] = testId;
        $[24] = t12;
    } else t12 = $[24];
    return t12;
} : ({ children: children, isFirstRowFull: isFirstRowFull, cardWidthOnFullRow: cardWidthOnFullRow, setWidth: setWidth, testId: testId = 'card-wrapper', scrollToCard: scrollToCard, clearScrollToCard: clearScrollToCard, index: index, requestScrollIndex: requestScrollIndex, cardId: cardId, extensionLocalId: extensionLocalId, itemDimensions: itemDimensions, hasInlinePadding: hasInlinePadding = false, ariaRole: ariaRole })=>{
    const cardRef = (0, $cozmU.useRef)(null);
    const [{ selectedExtensionLocalId: selectedExtensionLocalId, selectedToEditCardId: selectedToEditCardId }] = (0, $bIp5p.useExtensionsState)();
    const cardDimensions = itemDimensions;
    (0, $cozmU.useEffect)(()=>{
        const scrollIntoViewBehavior = {
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
        };
        if (cardRef.current) {
            // Scroll to this card as long as its config panel is open OR no config panel is open.
            // If no config panel is open, that covers the case in edit mode where user has clicked
            // scroll buttons on a row-oriented cards instance which they aren't actively editing.
            if (scrollToCard && (!selectedExtensionLocalId || extensionLocalId === selectedExtensionLocalId)) {
                cardRef.current.scrollIntoView(scrollIntoViewBehavior); // Clear scrollIndex to prevent re-invoking scroll effect later unexpectedly
                clearScrollToCard();
            } // Handle the case where user has selected this card to edit from the config panel.
            if (selectedToEditCardId && selectedToEditCardId === cardId && extensionLocalId === selectedExtensionLocalId) // Now that we've reached the right card that user is selecting to edit,
            // trigger the scrolling hook to recalculate scroll window and index so
            // that we can rerender invoking the scroll effect
            requestScrollIndex(index);
            else if (!selectedToEditCardId) // if no card is selected to edit, set index to -1 indicate that it is not currently being used
            requestScrollIndex(-1);
        }
    }, [
        cardRef,
        cardId,
        extensionLocalId,
        index,
        scrollToCard,
        clearScrollToCard,
        selectedExtensionLocalId,
        selectedToEditCardId,
        requestScrollIndex
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: ariaRole,
        style: {
            minWidth: isFirstRowFull ? `${cardWidthOnFullRow}px` : `${cardDimensions.minWidth}px`,
            maxWidth: isFirstRowFull ? `${cardWidthOnFullRow}px` : `${cardDimensions.maxWidth}px`
        },
        ref: cardRef,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $e48d13805ad5c50c$var$styles.wrapperStylesUpdated,
            hasInlinePadding && $e48d13805ad5c50c$var$styles.wrapperWithInlinePadding
        ])
    }, children, index === 0 && setWidth && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.WidthObserver), {
        setWidth: setWidth,
        offscreen: true
    }));
};
module.exports["CardOrientationWrapper"] = $e48d13805ad5c50c$export$11b226df951ea813;

});

parcelRegister("619Qo", function(module, exports) {

var $iaYF8 = parcelRequire("iaYF8");

const $33c8d037de0a9b07$export$fc883aabd3b0aeb1 = (imageUrl)=>{
    if (!imageUrl) return false;
    return imageUrl?.includes((0, $iaYF8.UNSPLASH_URL));
};
module.exports["isUnsplashImage"] = $33c8d037de0a9b07$export$fc883aabd3b0aeb1;

});

parcelRegister("iaYF8", function(module, exports) {
const $e492801ff53d3706$export$fe42ffbf1f8cac0e = 'unsplash';
const $e492801ff53d3706$export$9d9758c15e32e47a = 'minimal';
const $e492801ff53d3706$export$4eb66a6321d4a29c = 'color';
module.exports["UNSPLASH_URL"] = $e492801ff53d3706$export$fe42ffbf1f8cac0e;
module.exports["DEFAULT_UNSPLASH_QUERY_WORD"] = $e492801ff53d3706$export$9d9758c15e32e47a;
module.exports["PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD"] = $e492801ff53d3706$export$4eb66a6321d4a29c;

});

parcelRegister("dhLnb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $cfM7x = parcelRequire("cfM7x");


var $4ZwXK = parcelRequire("4ZwXK");


var $iMYjN = parcelRequire("iMYjN");

const $2b58b7b153b52d1e$var$unboundedStyles = {
    image: "_0jFU0VN91d _39xV02N91d _00EA0eiObl"
};
const $2b58b7b153b52d1e$export$a8e6523ab063becd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { contentId: contentId, imageSrc: imageSrc, imageAlt: imageAlt, shouldShowExternalSiteImage: shouldShowExternalSiteImage, customMediaAuthProvider: customMediaAuthProvider, customCollectionId: customCollectionId } = t0;
    const { experienceSuccessComponent: experienceSuccessComponent } = (0, $cfM7x.useProductDependencies)();
    if (!imageSrc) return null;
    const { showUnsplashImage: showUnsplashImage, showCustomUploadedImage: showCustomUploadedImage, showExternalSiteImage: showExternalSiteImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: imageSrc
    });
    const ExperienceSuccessComponent = experienceSuccessComponent || (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    if (showUnsplashImage || shouldShowExternalSiteImage && showExternalSiteImage) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = (0, $hekY6.default)([
                $2b58b7b153b52d1e$var$unboundedStyles.image
            ]);
            $[0] = t1;
        } else t1 = $[0];
        let t2;
        if ($[1] !== imageAlt || $[2] !== imageSrc || $[3] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
                "data-testid": "img-element",
                alt: imageAlt,
                src: imageSrc,
                className: t1
            });
            $[1] = imageAlt;
            $[2] = imageSrc;
            $[3] = t1;
            $[4] = t2;
        } else t2 = $[4];
        let t3;
        if ($[5] !== ExperienceSuccessComponent) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceSuccessComponent, null);
            $[5] = ExperienceSuccessComponent;
            $[6] = t3;
        } else t3 = $[6];
        let t4;
        if ($[7] !== t2 || $[8] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2, t3);
            $[7] = t2;
            $[8] = t3;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    } else if (showCustomUploadedImage) {
        let t1;
        if ($[10] !== customCollectionId || $[11] !== customMediaAuthProvider) {
            t1 = {
                collection: customCollectionId,
                authProvider: customMediaAuthProvider
            };
            $[10] = customCollectionId;
            $[11] = customMediaAuthProvider;
            $[12] = t1;
        } else t1 = $[12];
        let t2;
        if ($[13] !== contentId || $[14] !== imageAlt || $[15] !== imageSrc || $[16] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ZwXK.CustomImageUploadRenderer), {
                contentId: contentId,
                imageSrc: imageSrc,
                imageAltText: imageAlt,
                shouldShowErrorMessage: true,
                mediaConfigOverride: t1
            });
            $[13] = contentId;
            $[14] = imageAlt;
            $[15] = imageSrc;
            $[16] = t1;
            $[17] = t2;
        } else t2 = $[17];
        return t2;
    }
    let t1;
    if ($[18] !== ExperienceSuccessComponent) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceSuccessComponent, null);
        $[18] = ExperienceSuccessComponent;
        $[19] = t1;
    } else t1 = $[19];
    return t1;
} : ({ contentId: contentId, imageSrc: imageSrc, imageAlt: imageAlt, shouldShowExternalSiteImage: shouldShowExternalSiteImage, customMediaAuthProvider: customMediaAuthProvider, customCollectionId: customCollectionId })=>{
    const { experienceSuccessComponent: experienceSuccessComponent } = (0, $cfM7x.useProductDependencies)();
    if (!imageSrc) return null;
    const { showUnsplashImage: showUnsplashImage, showCustomUploadedImage: showCustomUploadedImage, showExternalSiteImage: showExternalSiteImage } = (0, $iMYjN.getImageTypeToShow)({
        imageSrc: imageSrc
    });
    const ExperienceSuccessComponent = experienceSuccessComponent || (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    if (showUnsplashImage || shouldShowExternalSiteImage && showExternalSiteImage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        "data-testid": "img-element",
        alt: imageAlt,
        src: imageSrc,
        className: (0, $hekY6.default)([
            $2b58b7b153b52d1e$var$unboundedStyles.image
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceSuccessComponent, null));
    else if (showCustomUploadedImage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ZwXK.CustomImageUploadRenderer), {
        contentId: contentId,
        imageSrc: imageSrc,
        imageAltText: imageAlt,
        shouldShowErrorMessage: true,
        mediaConfigOverride: {
            collection: customCollectionId,
            authProvider: customMediaAuthProvider
        }
    });
    // Fallback if nothing matches
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ExperienceSuccessComponent, null);
};
module.exports["ImageRenderer"] = $2b58b7b153b52d1e$export$a8e6523ab063becd;

});

parcelRegister("4ZwXK", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $lMGh1 = parcelRequire("lMGh1");


var $gIMcb = parcelRequire("gIMcb");


var $iQxQk = parcelRequire("iQxQk");


var $iMnC5 = parcelRequire("iMnC5");


var $b8pma = parcelRequire("b8pma");


var $cfM7x = parcelRequire("cfM7x");




const $b471e24caf412397$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    imageFailedMessage: {
        id: "company-hub.company-hub-common.link-cards.image-failed-to-load",
        defaultMessage: "Image failed to load"
    },
    warningIcon: {
        id: "company-hub.company-hub-common.link-cards.warning",
        defaultMessage: "Warning icon for image failed to load"
    }
});


const $71f5faa30087591b$var$IMAGE_CONFIGURATION = {
    allowAnimated: true,
    mode: 'fit',
    upscale: false
};
const $71f5faa30087591b$var$styles = {
    loading: "_39xV02N91d _0jFU0VN91d _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _0KLXrumhAQ",
    errorWrapper: "_3iDTPbQ4SZ _0aFT5vbt8w _39xV02N91d _0jFU0VN91d _37wbyuDIqT _0hPCNLDIqT _0KLXrumhAQ",
    image: "_0jFU0VN91d _39xV02N91d _3v5uP0ZqHV _00EA0eiObl"
};
const $71f5faa30087591b$export$3f3413d4a48facf = ({ contentId: contentId, imageSrc: imageSrc = '', imageAltText: imageAltText, mediaConfigOverride: mediaConfigOverride, shouldShowErrorMessage: shouldShowErrorMessage = false })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { experienceSuccessComponent: experienceSuccessComponent, experienceStopComponent: experienceStopComponent, useMediaConfig: useMediaConfig } = (0, $cfM7x.useProductDependencies)();
    const { authProvider: authProvider, collection: collection, fileId: fileId } = useMediaConfig?.({
        contentId: contentId,
        imageSrc: imageSrc
    }) || {};
    const resolvedAuthProvider = mediaConfigOverride?.authProvider ?? authProvider;
    const resolvedCollectionName = mediaConfigOverride?.collection ?? collection;
    const identifier = (0, $cozmU.useMemo)(()=>({
            mediaItemType: 'file',
            id: fileId ?? '',
            collectionName: resolvedCollectionName ?? ''
        }), [
        fileId,
        resolvedCollectionName
    ]);
    if (!resolvedAuthProvider || !resolvedCollectionName || !imageSrc) return null;
    const errorState = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $71f5faa30087591b$var$styles.errorWrapper,
        testId: "custom-image-upload-error"
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
        label: intl.formatMessage((0, $b471e24caf412397$export$defe85febe8b728c).warningIcon),
        color: "var(--ds-icon-subtle, #505258)"
    }), shouldShowErrorMessage && /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $b471e24caf412397$export$defe85febe8b728c).imageFailedMessage));
    const ExperienceSuccess = experienceSuccessComponent || (()=>null);
    const ExperienceError = experienceStopComponent || (()=>null);
    return /*#__PURE__*/ $cozmU.createElement((0, $gIMcb.MediaClientProvider), {
        clientConfig: {
            authProvider: resolvedAuthProvider
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $iQxQk.MediaImageWithErrorBoundary), {
        identifier: identifier,
        key: fileId,
        mediaClientConfig: {
            authProvider: resolvedAuthProvider
        },
        apiConfig: $71f5faa30087591b$var$IMAGE_CONFIGURATION
    }, ({ data: data, loading: loading, error: error })=>{
        if (loading) return /*#__PURE__*/ $cozmU.createElement((0, $b8pma.default), {
            name: "custom-uploaded-image-loading"
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            testId: "custom-image-upload-loading",
            xcss: $71f5faa30087591b$var$styles.loading
        }));
        if (error || !data?.src) return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, errorState, /*#__PURE__*/ $cozmU.createElement(ExperienceError, {
            error: new Error('Image failed to load in CustomImageUploadRenderer')
        }));
        return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement("img", {
            src: data.src,
            alt: imageAltText,
            "data-testid": "custom-image-upload",
            className: (0, $hekY6.default)([
                $71f5faa30087591b$var$styles.image
            ])
        }), /*#__PURE__*/ $cozmU.createElement(ExperienceSuccess, null));
    }));
};
module.exports["CustomImageUploadRenderer"] = $71f5faa30087591b$export$3f3413d4a48facf;

});

parcelRegister("iMYjN", function(module, exports) {

var $619Qo = parcelRequire("619Qo");

const $90ce04f031631e3a$export$25f23b916a7baf7 = ({ imageSrc: imageSrc })=>{
    const isAbsoluteUrl = /^https?:\/\//.test(imageSrc || '');
    const isFileId = !isAbsoluteUrl && Boolean(imageSrc?.match(/([0-9a-fA-F-]{36})/));
    const showCustomUploadedImage = !!imageSrc && isFileId;
    const showUnsplashImage = !showCustomUploadedImage && (0, $619Qo.isUnsplashImage)(imageSrc);
    const showExternalSiteImage = !!imageSrc && !showCustomUploadedImage && !showUnsplashImage;
    return {
        showUnsplashImage: showUnsplashImage,
        showExternalSiteImage: showExternalSiteImage,
        showCustomUploadedImage: showCustomUploadedImage,
        hasImage: showUnsplashImage || showCustomUploadedImage || showExternalSiteImage
    };
};
const $90ce04f031631e3a$export$af23f40d1cee8ded = (url)=>{
    return new Promise((resolve)=>{
        // Creating an image element in memory to verify if the URL is a valid image
        const img = new Image();
        img.onload = ()=>resolve(true);
        img.onerror = ()=>resolve(false);
        img.src = url;
    });
};
const $90ce04f031631e3a$export$6535eb414fa2c8b6 = (url)=>{
    const trimmedUrl = url.trim();
    // If it already has a protocol, return as is
    if (trimmedUrl.startsWith('http://') || trimmedUrl.startsWith('https://')) return trimmedUrl;
    // If it starts with //, add https:
    if (trimmedUrl.startsWith('//')) return `https:${trimmedUrl}`;
    // Otherwise, add https:// (default to secure)
    return `https://${trimmedUrl}`;
};
const $90ce04f031631e3a$export$bef94a5618bf18bf = (url)=>{
    const trimmedUrl = url.trim();
    // Handle empty strings
    if (!trimmedUrl) return false;
    // Check if it's already a valid URL with protocol
    if (trimmedUrl.startsWith('http://') || trimmedUrl.startsWith('https://')) try {
        new URL(trimmedUrl);
        return true;
    } catch  {
        return false;
    }
    // For URLs without protocol, check if they look like valid domains
    // This prevents things like "invalid-url" from being normalized to "https://invalid-url"
    if (trimmedUrl.startsWith('//')) {
        // Protocol-relative URLs should have a valid domain after //
        const domainPart = trimmedUrl.substring(2);
        return domainPart.includes('.') && !domainPart.includes(' ');
    }
    // For URLs without protocol, they should look like valid domains
    // Must contain a dot (for domain) and no spaces
    if (trimmedUrl.includes('.') && !trimmedUrl.includes(' ')) // Basic domain validation - should have at least one dot and no spaces
    return true;
    return false;
};
module.exports["getImageTypeToShow"] = $90ce04f031631e3a$export$25f23b916a7baf7;
module.exports["isImageURL"] = $90ce04f031631e3a$export$af23f40d1cee8ded;
module.exports["normalizeUrl"] = $90ce04f031631e3a$export$6535eb414fa2c8b6;
module.exports["isValidUrl"] = $90ce04f031631e3a$export$bef94a5618bf18bf;

});

parcelRegister("9n61H", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $w6R6I = parcelRequire("w6R6I");


var $l8Rhq = parcelRequire("l8Rhq");


var $3izAL = parcelRequire("3izAL");


var $2wCqQ = parcelRequire("2wCqQ");


var $6Pqow = parcelRequire("6Pqow");


var $buxP3 = parcelRequire("buxP3");


var $jIDse = parcelRequire("jIDse");


var $bIp5p = parcelRequire("bIp5p");


var $cfM7x = parcelRequire("cfM7x");


var $hjUDQ = parcelRequire("hjUDQ");

/**
 * Validates and sanitizes a URL to prevent XSS attacks.
 *
 * @param url - The URL to validate and sanitize
 * @returns The sanitized URL or empty string if unsafe
 *
 */ const $6bc04d1b1e105bec$export$a5e3d4c760ae8d05 = (url)=>{
    if (!url || typeof url !== 'string') return '';
    url = url.trim();
    try {
        // In case of SSR, global window may not have been initialized
        const baseUrl = typeof window !== 'undefined' ? window.location.origin : undefined;
        const parsed = new URL(url, baseUrl);
        if (![
            'http:',
            'https:',
            'mailto:',
            'tel:'
        ].includes(parsed.protocol)) return '';
        return parsed.href;
    } catch  {
        return '';
    }
};



var $aOuIh = parcelRequire("aOuIh");




const $b6e07e79e8f27afe$var$_default_1 = (0, $kSwu1.defineMessages)({
    placeholderButtonLabel: {
        id: "company-hub.company-hub-common.spotlight.button-label.placeholder",
        defaultMessage: "View"
    }
});
var $b6e07e79e8f27afe$export$2e2bcd8739ae039 = $b6e07e79e8f27afe$var$_default_1;


const $0db27e7cdeb13f7e$var$SPOTLIGHT_BREAKPOINTS = {
    small: 640,
    medium: 1400
};
const $0db27e7cdeb13f7e$var$styles = {
    baseWrapperStyles: "_0jFU0VN91d",
    smallStyles: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    mediumStyles: "_0Of8r2Va5s _1ZnuxbVa5s _1wydGWVa5s _2Zuz6QVa5s",
    largeStyles: "_0Of8r2GXk2 _1ZnuxbGXk2 _1wydGWGXk2 _2Zuz6QGXk2",
    largeTitle: "_2sNsIgxzFw",
    xlargeTitle: "_2sNsIgXwEm",
    xxlargeTitle: "_2sNsIgJ6H4",
    titleStyles: "_1kk5Tk7GSX",
    smallFrameStyles: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    mediumFrameStyles: "_0Of8r2NHnM _1wydGWNHnM _2Zuz6QVa5s _1ZnuxbVa5s",
    largeFrameStyles: "_0Of8r2Va5s _1ZnuxbVa5s _1wydGWVa5s _2Zuz6QVa5s"
};
const $0db27e7cdeb13f7e$export$c2176a81b9d23a65 = (width, layout)=>{
    if (layout === (0, $hjUDQ.CommonLayout).FRAME_ABOVE_IMAGE) {
        if (width < $0db27e7cdeb13f7e$var$SPOTLIGHT_BREAKPOINTS.small) return 'smallFrameStyles';
        if (width < $0db27e7cdeb13f7e$var$SPOTLIGHT_BREAKPOINTS.medium) return 'mediumFrameStyles';
        return 'largeFrameStyles';
    }
    if (width < $0db27e7cdeb13f7e$var$SPOTLIGHT_BREAKPOINTS.small) return 'smallStyles';
    if (width < $0db27e7cdeb13f7e$var$SPOTLIGHT_BREAKPOINTS.medium) return 'mediumStyles';
    return 'largeStyles';
};
const $0db27e7cdeb13f7e$var$baseButtonStyles = (0, $buxP3.xcss)({
    borderWidth: 'border.width',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "5px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-radius-small, 5px)",
    transition: 'background 0.1s ease-out',
    borderStyle: 'solid',
    borderColor: 'color.border',
    paddingBlock: 'space.100',
    paddingInline: 'space.150',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'none'
    }
});
const $0db27e7cdeb13f7e$var$defaultButtonStyles = (0, $buxP3.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    ':hover': {
        backgroundColor: 'elevation.surface.overlay.hovered'
    },
    ':active': {
        backgroundColor: 'elevation.surface.overlay.pressed'
    }
});
const $0db27e7cdeb13f7e$var$alternativeButtonStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.neutral.bold',
    ':hover': {
        backgroundColor: 'color.background.neutral.bold.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.bold.pressed'
    }
});
const $0db27e7cdeb13f7e$var$getTitleFontSize = (width)=>{
    if (width < $0db27e7cdeb13f7e$var$SPOTLIGHT_BREAKPOINTS.small) return 'largeTitle';
    if (width < $0db27e7cdeb13f7e$var$SPOTLIGHT_BREAKPOINTS.medium) return 'xlargeTitle';
    return 'xxlargeTitle';
};
const $0db27e7cdeb13f7e$var$getDescriptionSize = (width)=>{
    if (width < $0db27e7cdeb13f7e$var$SPOTLIGHT_BREAKPOINTS.small) return 'medium';
    return 'large';
};
const $0db27e7cdeb13f7e$var$getBaseLineCount = (isSplitLayout, width)=>{
    if (!isSplitLayout) return 8;
    if (width < $0db27e7cdeb13f7e$var$SPOTLIGHT_BREAKPOINTS.small) return 3;
    return 6;
};
const $0db27e7cdeb13f7e$var$getDescriptionMaxLines = (isSplitLayout, width, isButtonShown)=>{
    const lines = $0db27e7cdeb13f7e$var$getBaseLineCount(isSplitLayout, width);
    return isButtonShown ? lines - 2 : lines;
};
const $0db27e7cdeb13f7e$export$e0b309a29dbe6cbc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { isCompanyHub: isCompanyHub, useAnalyticsActions: useAnalyticsActions } = (0, $cfM7x.useProductDependencies)();
    const [t0] = (0, $bIp5p.useExtensionsState)();
    const { isInViewMode: isInViewMode } = t0;
    if (isCompanyHub && isInViewMode && typeof useAnalyticsActions?.useLinkAnalyticActions === "function") {
        let t1;
        if ($[0] !== props) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0db27e7cdeb13f7e$var$TrackedLinkContent, {
                key: props.link,
                ...props
            });
            $[0] = props;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0db27e7cdeb13f7e$var$SpotlightContentBase, props);
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props)=>{
    const { isCompanyHub: isCompanyHub, useAnalyticsActions: useAnalyticsActions } = (0, $cfM7x.useProductDependencies)();
    const [{ isInViewMode: isInViewMode }] = (0, $bIp5p.useExtensionsState)();
    if (isCompanyHub && isInViewMode && typeof useAnalyticsActions?.useLinkAnalyticActions === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0db27e7cdeb13f7e$var$TrackedLinkContent, {
        key: props.link,
        ...props
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0db27e7cdeb13f7e$var$SpotlightContentBase, props);
};
const $0db27e7cdeb13f7e$var$TrackedLinkContent = (props)=>{
    const { useAnalyticsActions: useAnalyticsActions } = (0, $cfM7x.useProductDependencies)();
    const safeUrl = props.isButtonShown ? (0, $6bc04d1b1e105bec$export$a5e3d4c760ae8d05)(props.link) : undefined;
    const analytics = useAnalyticsActions.useLinkAnalyticActions(safeUrl || '');
    const hasFiredView = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (safeUrl && !hasFiredView.current && analytics?.handleView) {
            analytics.handleView();
            hasFiredView.current = true;
        }
    }, [
        analytics,
        safeUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0db27e7cdeb13f7e$var$SpotlightContentBase, {
        ...props,
        onButtonClick: analytics?.handleClick
    });
};
const $0db27e7cdeb13f7e$var$SpotlightContentBase = ({ testId: testId, width: width = (0, $aOuIh.VERTICAL_MAX_WIDTH) + 1, layout: layout, textColor: savedTextColor, title: title, description: description, isButtonShown: isButtonShown, buttonText: buttonText, link: link, buttonStyle: buttonStyle, source: source, imageWidthPercentage: imageWidthPercentage = 0.5, onButtonClick: onButtonClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $cfM7x.useProductDependencies)();
    const isSplitLayout = layout !== (0, $hjUDQ.CommonLayout).NO_IMAGE_BACKGROUND && layout !== (0, $hjUDQ.CommonLayout).FRAME_ABOVE_IMAGE;
    const isDefaultButtonStyle = buttonStyle === (0, $hjUDQ.ButtonStyle).DEFAULT;
    const { getDarkModeCompatibleTextColor: getDarkModeCompatibleTextColor } = (0, $jIDse.useDarkModeColors)(isSSRProductInDarkMode);
    const textColor = getDarkModeCompatibleTextColor(savedTextColor);
    const handleButtonClick = (0, $cozmU.useCallback)(()=>{
        onButtonClick?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'spotlightButton',
                source: source
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        onButtonClick,
        source
    ]);
    const bodyTextMaxLines = (0, $cozmU.useMemo)(()=>$0db27e7cdeb13f7e$var$getDescriptionMaxLines(isSplitLayout, width, isButtonShown), [
        isSplitLayout,
        width,
        isButtonShown
    ]);
    const titleMaxLines = ()=>{
        if (!description) return 5;
        if (imageWidthPercentage > 0.5 && width < $0db27e7cdeb13f7e$var$SPOTLIGHT_BREAKPOINTS.small) return 2;
        return 3;
    };
    const safeUrl = (0, $6bc04d1b1e105bec$export$a5e3d4c760ae8d05)(link);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
        grow: "fill",
        space: width < $0db27e7cdeb13f7e$var$SPOTLIGHT_BREAKPOINTS.small ? 'space.150' : 'space.200',
        alignInline: "start",
        alignBlock: "center",
        xcss: (0, $w6R6I.cx)($0db27e7cdeb13f7e$var$styles.baseWrapperStyles, $0db27e7cdeb13f7e$var$styles[$0db27e7cdeb13f7e$export$c2176a81b9d23a65(width, layout)]),
        testId: testId
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
        align: "start",
        color: "inherit",
        maxLines: titleMaxLines(),
        testId: "spotlight-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    ), {
        style: {
            color: textColor
        },
        xcss: (0, $w6R6I.cx)($0db27e7cdeb13f7e$var$styles[$0db27e7cdeb13f7e$var$getTitleFontSize(width)], $0db27e7cdeb13f7e$var$styles.titleStyles)
    }, title)), description && bodyTextMaxLines > 0 && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: {
            color: textColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
        testId: "spotlight-description",
        align: "start",
        color: "inherit",
        size: $0db27e7cdeb13f7e$var$getDescriptionSize(width),
        maxLines: bodyTextMaxLines
    }, description)), isButtonShown && safeUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.Anchor), {
        onClick: handleButtonClick,
        href: safeUrl,
        xcss: [
            $0db27e7cdeb13f7e$var$baseButtonStyles,
            isDefaultButtonStyle ? $0db27e7cdeb13f7e$var$defaultButtonStyles : $0db27e7cdeb13f7e$var$alternativeButtonStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
        weight: "medium",
        color: isDefaultButtonStyle ? 'color.text' : 'color.text.inverse',
        maxLines: 1
    }, buttonText || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $b6e07e79e8f27afe$export$2e2bcd8739ae039).placeholderButtonLabel))));
};
module.exports["SpotlightContent"] = $0db27e7cdeb13f7e$export$e0b309a29dbe6cbc;

});

parcelRegister("aOuIh", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $jIDse = parcelRequire("jIDse");


var $eafQX = parcelRequire("eafQX");


var $cfM7x = parcelRequire("cfM7x");


var $51SAu = parcelRequire("51SAu");


var $hjUDQ = parcelRequire("hjUDQ");


var $4WDWC = parcelRequire("4WDWC");

const { NO_IMAGE_BACKGROUND: $f0fd9cc53505a377$var$NO_IMAGE_BACKGROUND, SPLIT_IMAGE_LEFT: $f0fd9cc53505a377$var$SPLIT_IMAGE_LEFT, SPLIT_IMAGE_RIGHT: $f0fd9cc53505a377$var$SPLIT_IMAGE_RIGHT, FRAME_ABOVE_IMAGE: $f0fd9cc53505a377$var$FRAME_ABOVE_IMAGE } = (0, $hjUDQ.CommonLayout); /**
                   * The maximum width in pixels at which the layout is oriented vertically, at larger widths it is horizontal.
                   */ 
const $f0fd9cc53505a377$export$a24d4999f7186564 = 640;
const $f0fd9cc53505a377$var$FRAME_MAX_WIDTH = 486;
const $f0fd9cc53505a377$var$CENTERED_FRAME_WIDTH = 364;
const $f0fd9cc53505a377$var$WIDE_FRAME_WIDTH = 393;
const $f0fd9cc53505a377$var$FULL_WIDTH_FRAME_WIDTH = 512;
const $f0fd9cc53505a377$var$percentageStyles = {
    flex: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0jFU0VN91d",
    imageSide: "_2O5VijdnbC _3YEZNOdnbC",
    childrenSide: "_2O5Vij7dHp",
    borderStyle: "_30huDKOeNX"
};
const $f0fd9cc53505a377$var$gridStyles = {
    grid: "_3iDTPbgBM8 _0jFU0VN91d _0ca6V7clzJ",
    frameChildren: "_0bjKvD8fU6 _2j3gqAtfzM _3B2K2QE1JG _2YLqiKVa5s",
    fullImage: "_4bt5LAnQyn _2WAcuGnQyn _30huDKOeNX _2j3gqAg8pm _3B2K2Qg8pm _0jFU0VN91d",
    roundedBorderRadius: "_0bjKvDyzSk",
    smallFrameStyling: "_2YLqiK5zaO _1EqgXlq322",
    centeredFrameStyling: "_2YLqiKVa5s _39xV02UTds _1EqgXlq322",
    wideFrameStyling: "_2YLqiKVa5s _39xV02ky9M _1EqgXlq322",
    fullWidthFrameStyling: "_2YLqiKGXk2 _39xV026PwL"
};
function $f0fd9cc53505a377$var$spotlightToCssHeight(height) {
    switch(height){
        case (0, $hjUDQ.Height).SMALL:
            return 248;
        case (0, $hjUDQ.Height).MEDIUM:
            return 400;
        case (0, $hjUDQ.Height).LARGE:
        default:
            return 620;
    }
}
var $f0fd9cc53505a377$export$262fb604e10a6da8 = /*#__PURE__*/ function(SpotlightWidth) {
    SpotlightWidth[SpotlightWidth["SMALL"] = 356] = "SMALL";
    SpotlightWidth[SpotlightWidth["CENTERED"] = 800] = "CENTERED";
    SpotlightWidth[SpotlightWidth["WIDE"] = 1050] = "WIDE";
    SpotlightWidth[SpotlightWidth["FULL_WIDTH"] = 1840] = "FULL_WIDTH";
    return SpotlightWidth;
}({});
function $f0fd9cc53505a377$export$e2db3adb05a4002(width) {
    if (width <= 356) return 'smallFrameStyling';
    if (width <= 800) return 'centeredFrameStyling';
    if (width <= 1050) return 'wideFrameStyling';
    return 'fullWidthFrameStyling';
}
function $f0fd9cc53505a377$export$40cf3f2715085991({ backgroundColor: savedBackgroundColor, children: children, cornerRadiusOverride: cornerRadiusOverride, height: height, image: image, layout: layout, testId: testId, width: width = $f0fd9cc53505a377$export$a24d4999f7186564 + 1, imageWidthPercentage: imageWidthPercentage = 0.5, hasRoundedCorners: hasRoundedCorners }) {
    const { isSSRProductInDarkMode: isSSRProductInDarkMode, hideExtensionBorders: hideExtensionBorders } = (0, $cfM7x.useProductDependencies)();
    const { getDarkModeCompatibleBackgroundColor: getDarkModeCompatibleBackgroundColor } = (0, $jIDse.useDarkModeColors)(isSSRProductInDarkMode);
    const backgroundColor = getDarkModeCompatibleBackgroundColor(savedBackgroundColor);
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)(); // Per-element corner radius is Premium. The value lives in the ADF, so a
    // downgrade cannot clear it — ignoring the override makes the extension
    // inherit the hub-wide radius, which the backend resets to the 8px default.
    const isCornerRadiusLocked = (0, $51SAu.useShouldShowPremiumUpsell)();
    if (!image) layout = $f0fd9cc53505a377$var$NO_IMAGE_BACKGROUND;
    const showVerticalLayout = width < $f0fd9cc53505a377$export$a24d4999f7186564; // In the small-height layout, if there's an image, its width is fixed:
    let imageWidth;
    if (height === (0, $hjUDQ.Height).SMALL && (layout === $f0fd9cc53505a377$var$SPLIT_IMAGE_LEFT || layout === $f0fd9cc53505a377$var$SPLIT_IMAGE_RIGHT)) {
        if (width >= 1024) imageWidth = 514;
        else if (width >= 768) imageWidth = 186;
        else if (width > $f0fd9cc53505a377$export$a24d4999f7186564) imageWidth = 140;
        else imageWidth = 84;
    }
    const getFlexDirection = ()=>{
        if (showVerticalLayout) return layout === $f0fd9cc53505a377$var$SPLIT_IMAGE_LEFT ? 'column' : 'column-reverse';
        return layout === $f0fd9cc53505a377$var$SPLIT_IMAGE_LEFT ? 'row' : 'row-reverse';
    };
    return layout === $f0fd9cc53505a377$var$FRAME_ABOVE_IMAGE ? /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        style: {
            height: `${$f0fd9cc53505a377$var$spotlightToCssHeight(height)}px`
        },
        className: (0, $hekY6.default)([
            $f0fd9cc53505a377$var$gridStyles.grid
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId ? `${testId}-image` : undefined,
        style: isCornerRadiusEnabled ? {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            borderRadius: `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})`,
            ...!isCornerRadiusLocked && typeof cornerRadiusOverride === 'number' ? {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                [(0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR)]: `${(0, $4WDWC.resolveHubCornerRadius)(cornerRadiusOverride)}px`
            } : {}
        } : undefined,
        className: (0, $hekY6.default)([
            $f0fd9cc53505a377$var$gridStyles.fullImage,
            hasRoundedCorners && $f0fd9cc53505a377$var$gridStyles.roundedBorderRadius
        ])
    }, image), /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            backgroundColor: backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...isCornerRadiusEnabled ? {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                borderRadius: `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})`,
                ...!isCornerRadiusLocked && typeof cornerRadiusOverride === 'number' ? {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    [(0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR)]: `${(0, $4WDWC.resolveHubCornerRadius)(cornerRadiusOverride)}px`
                } : {}
            } : {}
        },
        className: (0, $hekY6.default)([
            $f0fd9cc53505a377$var$gridStyles.frameChildren,
            $f0fd9cc53505a377$var$gridStyles[$f0fd9cc53505a377$export$e2db3adb05a4002(width)]
        ])
    }, children)) : /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        style: {
            backgroundColor: backgroundColor,
            height: `${$f0fd9cc53505a377$var$spotlightToCssHeight(height)}px`,
            flexDirection: getFlexDirection(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...isCornerRadiusEnabled ? {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                borderRadius: `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})`,
                ...!isCornerRadiusLocked && typeof cornerRadiusOverride === 'number' ? {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    [(0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR)]: `${(0, $4WDWC.resolveHubCornerRadius)(cornerRadiusOverride)}px`
                } : {}
            } : {
                borderRadius: hasRoundedCorners ? "var(--ds-radius-xlarge, 12px)" : 0
            }
        },
        className: (0, $hekY6.default)([
            $f0fd9cc53505a377$var$percentageStyles.flex,
            !hideExtensionBorders && $f0fd9cc53505a377$var$percentageStyles.borderStyle
        ])
    }, layout !== $f0fd9cc53505a377$var$NO_IMAGE_BACKGROUND && /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            flexBasis: imageWidth || `${imageWidthPercentage * 100}%`,
            height: showVerticalLayout ? `${$f0fd9cc53505a377$var$spotlightToCssHeight(height) * imageWidthPercentage}px` : '100%'
        },
        className: (0, $hekY6.default)([
            $f0fd9cc53505a377$var$percentageStyles.imageSide
        ])
    }, image), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $f0fd9cc53505a377$var$percentageStyles.childrenSide
        ])
    }, children));
}
module.exports["VERTICAL_MAX_WIDTH"] = $f0fd9cc53505a377$export$a24d4999f7186564;
module.exports["SpotlightLayout"] = $f0fd9cc53505a377$export$40cf3f2715085991;

});


//# sourceMappingURL=cards-extension.074afa57.js.map
